import { Component, Inject, Input, OnChanges, OnInit} from '@angular/core';
import {  DOCUMENT } from '@angular/common';

const S3_BASE_URL = 'https://s3.eu-west-1.amazonaws.com/merlin.files/';
const FILES_BASE_URL = 'https://files.merlinapps.es/s3/';

@Component({
  selector: 'app-share',
  templateUrl: './share.component.html'
})
export class ShareComponent implements OnChanges, OnInit {
  @Input() title: string = '';
  @Input() description?: string = '';
  @Input() image?: string;

  sanitizedDescription: string = '';
  isShareSupported: boolean = false;

  constructor(
    @Inject(DOCUMENT) private document: any,
  ) {}

  ngOnInit() {
    this.isShareSupported = !!navigator.share;
  }

  ngOnChanges() {
    this.sanitizedDescription = this.stripHtml(this.description);
  }

  stripHtml(html: string): string {
    const doc = new DOMParser().parseFromString(html, 'text/html');
    return doc.body.textContent || "";
  }

  async share() {
    const data: ShareData = {
      title: this.title,
      text: this.sanitizedDescription,
      url: this.document.location.href
    };

    const file = await this.getImageFile();
    if (file && navigator.canShare?.({ files: [file] })) {
      data.files = [file];
    }

    try {
      await navigator.share(data);
    } catch (error) {
      if (error?.name === 'AbortError') {
        return;
      }
      if (data.files) {
        delete data.files;
        await navigator.share(data).catch(() => undefined);
      }
    }
  }

  private async getImageFile(): Promise<File | null> {
    if (!this.image) {
      return null;
    }
    try {
      const response = await fetch(this.image.replace(S3_BASE_URL, FILES_BASE_URL));
      if (!response.ok) {
        return null;
      }
      const blob = await response.blob();
      const extension = blob.type.split('/')[1]?.split('+')[0] || 'jpg';
      return new File([blob], `preview.${extension}`, { type: blob.type });
    } catch {
      return null;
    }
  }
}
